<template>
  <div style="color: #4a4a4a; font-size: 14px">
    <div class="steps-title">注册流程说明</div>
    <div class="steps-list">
      <template v-if="otype == 9">
        <p>1.您注册的手机号后续将作为会员登录帐号，请悉知。</p>
        <p>
          2.下载<span class="adownload" @click="templateDownload"
            >授权委托书模板</span
          >，请填写授权委托书并加盖公司公章。
        </p>
        <p>
          3.下载<span class="adownload" @click="xyDownload"
            >承运商合作框架协议模板</span
          >，并进行协议签约并加盖公司公章。
        </p>
        <p>
          4.在开店申请时，上传加盖公司公章的<span style="color: #0089ef"
            >《授权委托书》</span
          >和<span style="color: #0089ef">《承运商合作框架协议》</span
          >电子文件（pdf格式）。
        </p>
        <p>
          5.请根据表单要求填写，确保填写信息准确无误。
          <!-- 5.扫码支付店铺服务费。店铺服务费标准为: -->
          <!-- <span style="color: #ff142f">￥{{ cost }}元/年。 {{ tip }}</span> -->
        </p>
        <div class="zhu" style="max-width: 800px; color: #ff142f">
          <!-- 承运商在中交物流平台注册开店，成为物流专区会员，享受专区增值服务：1.打破法人墙，不受“合作意向单位“限制，可以参与物流专区所有物流业务报名报价；2.通过专区门户“货找车”专栏对会员单位进行展现、推广、宣传；3.提供项目信息、精准推送，提供有价值的物流需求业务，系统智能匹配，形成撮合交易服务；4.提供中交集团在建项目信息、数据信息查询、竞争对手分析、供应链金融服务、全流程短信提醒、专属客户经理、行业数据分析等高附加值服务。 -->
        </div>
      </template>
      <template v-else>
        <p>
          1.下载<span class="adownload" @click="templateDownload"
            >授权委托书模板</span
          >。
        </p>
        <p>2.填写授权委托书并加盖公司公章。</p>
        <p>
          3.在开店申请时，上传加盖公司公章的授权委托书电子文件（pdf 格式）。
        </p>
        <p v-if="showitems">
          4.扫码支付店铺服务费。店铺服务费标准为:
          <span style="color: #ff142f">￥{{ cost }}元/年。 {{ tip }}</span>
        </p>
        <div class="zhu" v-if="showitems">
          注：店铺服务包含系统和业务培训、平台店铺管理服务、商品管理服务、订单处理服务、物流实时追踪、客户服务、数据分析、用户信息安全保障等。
        </div>
      </template>
    </div>
    <div style="height: 164px"></div>
  </div>
</template>

<script>
import {
  templateDownloadwlxt,
  templateDownloadzlxt,
  templateDownloadjcxt,
  templateDownloadckxt,
  templateDownloadhzkjxy,
} from "@/api/lessor-open-shop.js";
import { Loading } from "ccui";
export default {
  props: {
    cost: {
      type: String,
      default: "3000.00",
    },
  },
  data() {
    return {
      loadingObj: null,
      xyFileUrl:
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100112/default/202506/c8b6c97485074ec280d91328a5a273bc.pdf",
    };
  },
  computed: {
    otype() {
      return this.$route.query.orderPurchaseType || 8;
    },
    showitems() {
      // 中交云租》租赁商开店申请》注册须知页面，隐藏注册流程说明中的第4点及提示注意信息  20250-04-10 需求
      const type = this.$route.query.orderPurchaseType || 8;
      return type != 8;
    },
    tip() {
      const orderPurchaseType = this.$route.query.orderPurchaseType || 8;
      if (orderPurchaseType == "8") {
        return "(试运行期间不收取服务费用)";
      } else {
        return "";
      }
    },
  },
  methods: {
    templateDownload() {
      // 8 云租 9 物流 10 二级集采
      const orderPurchaseType = this.$route.query.orderPurchaseType || 8;
      if (orderPurchaseType == "8") {
        templateDownloadzlxt().then((res) => {
          this.handelDownload(res);
        });
      } else if (orderPurchaseType == "9") {
        templateDownloadwlxt().then((res) => {
          this.handelDownload(res);
        });
      } else if (orderPurchaseType == "10") {
        templateDownloadjcxt().then((res) => {
          this.handelDownload(res);
        });
      } else if (orderPurchaseType == "11") {
        templateDownloadckxt().then((res) => {
          this.handelDownload(res);
        });
      }
    },
    xyDownload() {
      this.showLoading();
      templateDownloadhzkjxy()
        .then((res) => {
          this.handelDownload(res);
        })
        .finally(() => {
          this.hideLoading();
        });
      // let elink = document.createElement("a");
      // elink.download = "承运商合作框架协议.pdf";
      // elink.style.display = "none";
      // elink.href = this.xyFileUrl;
      // document.body.appendChild(elink);
      // elink.click();
      // document.body.removeChild(elink);
    },
    previewXyFileUrl() {
      window.open(this.xyFileUrl, "_blank");
    },
    handelDownload(res) {
      let blob = new Blob([res.data], {
        type: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob);
      } else {
        let elink = document.createElement("a");
        if (
          res.headers["content-disposition"] &&
          res.headers["content-disposition"].split(";").length > 1 &&
          res.headers["content-disposition"].split(";")[1].split("filename*=")
            .length > 1
        ) {
          let filename = res.headers["content-disposition"]
            .split(";")[1]
            .split("filename*=")[1];
          filename = window.decodeURIComponent(filename);
          filename = filename.split("utf-8''")[1];
          console.log(filename);
          elink.download = filename;
        }
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      }
    },
    showLoading() {
      this.loadingObj = Loading.service({
        lock: true,
        text: "下载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading",
      });
    },
    hideLoading() {
      this.loadingObj && this.loadingObj.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.steps-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
}
.zhu {
  font-size: 12px;
  color: #999;
}
.steps-list {
  font-size: 14px;
  line-height: 32px;
  font-weight: 400;
  .adownload {
    cursor: pointer;
    color: #0089ef;
    text-decoration: underline;
  }
}
</style>